import React from 'react';
import { Link } from 'react-router-dom';
import './estilo.css';


import Protecao from '../../assets/protecao360branca.svg'

function Topo(){
  function menuShow() {
    let menuMobile = document.querySelector('.mobile-menu');
    if (menuMobile.classList.contains('open')) {
      menuMobile.classList.remove('open');
      document.querySelector('.icon').src = require('../../assets/menu.png');
    } else {
      menuMobile.classList.add('open');
      document.querySelector('.icon').src = require('../../assets/close.png');
    }
  }

  return (
  <header>
    <div className="conteudo-topo limita-largura">
      {/* <Link to='/'><img className="logo-marca" alt='Logomarca Beneficium' src={require('../../assets/logo-vazada.png')}/></Link> */}
      <Link to='/'><img width={201} className="logo-marca" alt='Logomarca Beneficium' src={Protecao}/></Link>

      <nav className="menu-desktop">
        <Link className="link-navegacao" to='/'>Home</Link>
        <Link className="link-navegacao" to='/contato'>Contato</Link>
        <Link className="link-navegacao" to='/treinamentos'>Treinamentos</Link>
      </nav>

      <div className="mobile-menu-icon">
        <button onClick={menuShow}><img className='icon' alt='Menu' src={require('../../assets/menu.png')}/></button>
      </div>
    </div>

    <div className="mobile-menu">
      <nav className="nav-mobile">
        <Link className="link-navegacao" to='/'>Home</Link>
        <Link className="link-navegacao" to='/contato'>Contato</Link>
        <Link className="link-navegacao" to='/treinamentos'>Treinamentos</Link>
      </nav>
    </div>
  </header>
);
}

export default Topo;